import React from 'react';
import './circle.css'; // Créez ce fichier CSS
import CircularProgress from '@mui/material/CircularProgress';

const SnakeLoader = () => {
  return (
    <div className="loader-container">
{/*
      <svg className="snake-loader" viewBox="0 0 50 50">
        <circle
          cx="25"
          cy="25"
          r="20"
          fill="none"
          stroke="#4CAF50"
          strokeWidth="4"
          strokeLinecap="round"
          strokeDasharray="187 187"
          strokeDashoffset="0"
        />
        <circle cx="25" cy="5" r="3" fill="#4CAF50" />
      </svg>
*/}
<CircularProgress color="success" size={60} />

    </div>
  );
};

export default SnakeLoader;